@if (alert.visible) {
<div
  class="alert alert-{{alert.type}} alert-dismissible alert-position"
  role="alert">

  {{ alert.message }}

  <button
    type="button"
    class="btn-close"
    (click)="close()">
  </button>
</div>
}